var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { AlertWrapper, AlertIcon, AlertAction, AlertContent, Label, Title } from './styles';
// @ts-expect-error
import loadingLottie from '../../../assets/animations/lottie-loading.json';
import { Icon } from '../Icon';
import { LottieAnimation } from '../LottieAnimation';
export var getIconColor = function (type, theme) {
  switch (type) {
    case 'success':
      return theme.tokens.interface.feedback.positive.strong;
    case 'warning':
      return theme.tokens.interface.feedback.warning.strong;
    case 'error':
      return theme.tokens.interface.feedback.negative.strong;
    case 'tip':
      return theme.tokens.interface.feedback.tip.strong;
    case 'info':
    default:
      return theme.tokens.interface.feedback.info.strong;
  }
};
export var Alert = function (_a) {
  var _b = _a.type,
    type = _b === void 0 ? 'info' : _b,
    title = _a.title,
    message = _a.message,
    action = _a.action,
    _c = _a.withoutIcon,
    withoutIcon = _c === void 0 ? false : _c,
    withoutBorder = _a.withoutBorder,
    icon = _a.icon,
    rest = __rest(_a, ["type", "title", "message", "action", "withoutIcon", "withoutBorder", "icon"]);
  var theme = useTheme();
  var getIconForAlertType = function (type) {
    var commonIconProps = {
      size: 24,
      color: getIconColor(type, theme)
    };
    switch (type) {
      case 'loading':
        return _jsx(LottieAnimation, {
          data: loadingLottie,
          loop: true
        });
      case 'error':
        return _jsx(Icon, __assign({}, commonIconProps, {
          type: "icon-exclamation-hexagonal"
        }));
      case 'warning':
        return _jsx(Icon, __assign({}, commonIconProps, {
          type: "icon-exclamation-triangle"
        }));
      case 'success':
        return _jsx(Icon, __assign({}, commonIconProps, {
          type: "icon-check-circle"
        }));
      case 'info':
        return _jsx(Icon, __assign({}, commonIconProps, {
          type: "icon-info-circle"
        }));
      case 'tip':
        return _jsx(Icon, __assign({}, commonIconProps, {
          type: icon || 'icon-bulb'
        }));
    }
  };
  return _jsxs(AlertWrapper, __assign({
    type: type,
    withoutBorder: withoutBorder
  }, rest, {
    children: [!withoutIcon && _jsx(AlertIcon, {
      children: getIconForAlertType(type)
    }), _jsxs(AlertContent, {
      children: [title && _jsx(Title, {
        el: "div",
        styleName: "label",
        children: title
      }), _jsx(Label, {
        styleName: "bodyRegular",
        el: "div",
        children: message
      })]
    }), action && _jsx(AlertAction, {
      children: action
    })]
  }));
};